import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { getAddressString } from "@msuite/utils/strings";
import type { Tables } from "@msuite/utils/types";
import { ContactInformation } from "./contact-information";

/** Props Interface */
interface ContactHeaderProps {
	contact: Tables<"contacts">;
}

export function ContactHeader({ contact }: ContactHeaderProps) {
	/** Render */
	return (
		<ContentCard
			title={contact?.name ?? "N/A"}
			icon={icon("Building")}
			identifier={contact.id}
		>
			<p>{getAddressString(contact)}</p>
			<ContactInformation contact={contact} />
		</ContentCard>
	);
}
